import $ from 'jquery';

$(function () {
  if ($('#modal-video-player').length) {
    const $modalVideoPlayer = $('#modal-video-player');
    const $button = $('[data-action');

    if ($button.data('action')) {
      $button.on('click', (event) => {
        const { action, type } = $(event.currentTarget).data();
        let typeUrl = '';

        switch (type) {
          case 'youtube':
            typeUrl = 'https://www.youtube.com/embed';

            break;
          case 'vimeo':
            typeUrl = 'https://player.vimeo.com/video';

            break;
        }

        $modalVideoPlayer.attr('src', `${typeUrl}/${action}`);
      });
    }
  }
});
